function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Tabs, Space } from "antd";
import { InboxFill, FileEarmarkBreakFill, ShareFill, Pc, Plus } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import WorkbooksView from "../components/WorkbooksView";
import AddDocument from "../components/forms/AddDocument";
import AddWorkbook from "../components/forms/AddWorkbook";
import SharedView from "../components/SharedView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Document = function Document() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataChanged = _useState2[0],
    setIsDataChanged = _useState2[1];
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(Pc, {
            size: 25
          }), /*#__PURE__*/_jsx(Pc, {
            size: 25
          }), /*#__PURE__*/_jsx(Pc, {
            size: 25
          }), "CLASSEURS"]
        })
      })
    }),
    children: /*#__PURE__*/_jsx(WorkbooksView, {
      refresh: isDataChanged
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ShareFill, {
        size: 25
      }), " ELEMENTS PARTAGES"]
    }),
    children: /*#__PURE__*/_jsx(SharedView, {})
  }, {
    key: 3,
    label: /*#__PURE__*/_jsx(Space, {
      direction: "horizontal",
      children: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(Plus, {
          size: 22
        }), " NOUVEAU CLASSEUR"]
      })
    }),
    children: /*#__PURE__*/_jsx(AddWorkbook, {
      hanlder: function hanlder() {
        setIsDataChanged(true);
      }
    })
  }];
  useEffect(function () {
    setIsDataChanged(false);
  }, [isDataChanged]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Tabs, {
            items: tabItems,
            animated: true
          })
        })
      })
    })
  });
};
export default Document;